<!--
  Auth bridge (see auth-bridge-page.ts). Communicates with the parent via
  postMessage and renders nothing — except, when the browser needs a user
  gesture to grant storage access, a single button. The click on this button is
  the gesture that requestStorageAccess()/the Auth0 popup require.
-->
@if (needsGesture()) {
  <div class="bridge-prompt">
    <button type="button" class="bridge-btn" (click)="continueAsBrafton()" [disabled]="busy()">
      {{ busy() ? 'Checking…' : 'Continue as Brafton user' }}
    </button>
  </div>
}
